import React from "react";
import { AiOutlineLink } from "react-icons/ai";
import { FaPrayingHands } from "react-icons/fa";
import { Link } from "react-router-dom";
import { FACEBOOK, WHATSAPP } from "../assets/images";

const Sidebar = () => {
  return (
    <section className="py-md-5">
      <div className="text-secondary">
        <h3 className="text-light-gray">Important Links</h3>
        <br />
        <ul type="none" className="p-0">
          <li>
            <Link
              to={{ pathname: "https://upmsp.edu.in/" }}
              className="text-decoration-none text-secondary"
              target="_blank"
            >
              <AiOutlineLink className="text-warning" /> उत्तर प्रदेश माध्यमिक
              शिक्षा परिषद् -(UPMSP)
            </Link>
          </li>
          <li>
            <Link
              to={{ pathname: "https://upresults.nic.in/" }}
              className="text-decoration-none text-secondary"
              target="_blank"
            >
              <AiOutlineLink className="text-warning" /> Uttar Pradesh Results
            </Link>
          </li>
          <li>
            <Link
              to={{ pathname: "https://scholarship.up.gov.in/" }}
              className="text-decoration-none text-secondary"
              target="_blank"
            >
              <AiOutlineLink className="text-warning" /> UP Scholarship
            </Link>
          </li>
        </ul>
      </div>
      <div>
        <h3 className="text-light-gray  z-index-1">Notice Board</h3>
        <div>
          <ul type="none" className="p-0">
            <li>
              <Link to="/" className="text-decoration-none text-secondary">
                <FaPrayingHands className="text-warning" />
                &nbsp;
                <span>Welcome to our College Website.</span>
              </Link>
            </li>
            <li className="mt-1">
              <Link
                to={{ pathname: "https://scholarship.up.gov.in/" }}
                className="text-decoration-none text-secondary"
                target="_blank"
              >
                <AiOutlineLink className="text-warning" /> छात्रवृत्ति फॉर्म भरा
                जा रहा है। अतः शीघ्र ही छात्रवृत्ति फॉर्म को भरने का प्रयास करे.
              </Link>
            </li>
          </ul>
        </div>
      </div>
      <div className="my-5">
        <img
          src={FACEBOOK}
          alt="facebook "
          className="w-100 rounded"
          style={{ border: "2px dotted #ffc107" }}
        />

        <Link
          to={{
            pathname:
              "https://api.whatsapp.com/send/?phone=9451871624&text&app_absent=0",
          }}
          target="_blank"
        >
          <img src={WHATSAPP} alt="Whatsapp " className="w-100 mt-3" />
        </Link>
      </div>
    </section>
  );
};

export default Sidebar;
